import baseAPI from '@/api/base';
import { EditPayrollComponent, GetPayrollComponent, RegisterPayrollComponent } from '@/dtos/payroll_component.dto';
import {
  DELETE_PAYROLL_COMPONENT_URL,
  EDIT_PAYROLL_COMPONENT_URL,
  GET_PAYROLL_COMPONENT_URL,
  REGISTER_PAYROLL_COMPONENT_URL,
  TOGGLE_PAYROLL_COMPONENT_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class PayrollComponent {
  static getPayrollComponents = async (getPayrollComponent: GetPayrollComponent): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PAYROLL_COMPONENT_URL, {
      params: getPayrollComponent,
    });
    console.log('response', response);
    return response;
  };

  static registerPayrollComponent = async (
    registerPayrollComponent: RegisterPayrollComponent
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_PAYROLL_COMPONENT_URL, {
      ...registerPayrollComponent,
    });
    console.log('response', response);
    return response;
  };

  static editPayrollComponent = async (editPayrollComponent: EditPayrollComponent): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_PAYROLL_COMPONENT_URL, {
      ...editPayrollComponent,
    });
    return response;
  };

  static togglePayrollComponentIsActive = async (
    editPayrollComponent: EditPayrollComponent
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_PAYROLL_COMPONENT_IS_ACTIVE_URL,
      {
        ...editPayrollComponent,
      }
    );
    return response;
  };

  static deletePayrollComponent = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_PAYROLL_COMPONENT_URL}/${userId}`
    );
    return response;
  };
}

export default PayrollComponent;
